export default function MessagesData () {
    return ( 
        <div className='App'>
            <br></br>            
            <br></br>
            <h1 className="text-center emphTitle">MESSAGES AND ALERTS</h1>
            <br></br>
            <hr></hr>
        </div>
    );
}